import React from 'react';
import FormInput from '../Form/FormInput';
import StringSelector from '../Form/StringSelector';
import { Row, Col,Button,Label } from 'reactstrap';
import { useFormikContext } from 'formik';
import { roles,endpoints } from '../../utils/Constants';
import EntityStatusSelector from '../Form/EntityStatusFormSelector';
import { useFetchEntity } from '../../Services/fetchApi';
import { useEdit } from '../../Services/EditContext';
import SelectSetting from '../Form/SelectSetting';
import LoadingAnimation from '../Form/LoadingAnimation';




const AllowedActionDetail = () => {
    const { values, setFieldValue } = useFormikContext();
    const [settings, loadingSettings, error] = useFetchEntity({ name: 'AllowedActionsOptions', getByStatus: () => endpoints.getAllowedActionsOptions });
    const [edit] = useEdit()
    const actionType = settings ? settings.actionType : null;
    const dataTypeRequired = settings ? settings.dataTypeRequired : null;
    const actionCondition = settings ? settings.actionCondition : null;
    const dataEntryFilter = settings ? settings.dataEntryFilter : null; 
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    const roleNames = roles.map(x => x.name);
    const addDataEntry = () => {
        setFieldValue(values.dataEntry.push({}));
    }
    const removeDataEntry = (index) => { 
        let de = values.dataEntry;
        de.splice(index, 1);
        setFieldValue('dataEntry', de);
    }
    return <React.Fragment>
        <h4>{values.entityType} - {values.entityState}</h4>
        {loadingSettings ? <LoadingAnimation /> : null}
        {error?<h6>Error Loading Actions Options</h6>:null}
        <StringSelector id='allowedRole' label="Role" stringType list={roleNames} />
        <FormInput id='actionName' label='Action Name' />
       
        <StringSelector id={`allowedStatus`} stringType label="User Status" list={['Active','Inactive']} />
        
        <StringSelector id={'condition'} label="Condition" list={actionCondition ? actionCondition : []} />
        
                {actionType ? <StringSelector id='actionType' label="Action Type" list={actionType ? actionType : []} /> : null}
                {edit ? <Button onClick={() => addDataEntry()}>Add Data Entry</Button> : null}
                      {values.dataEntry && values.dataEntry.map((v, i) => {
                          return <Row key={i}>
                                    <Col>
                                        <StringSelector id={`dataEntry[${i}].dataTypeRequired`} label="Data Type" list={dataTypeRequired ? dataTypeRequired : []} />
                                    </Col>
                                    <Col>
                                        <StringSelector id={`dataEntry[${i}].dataEntryFilter`} label="Only when:" list={dataEntryFilter ? dataEntryFilter : []} />
                                    </Col>
                              <Col>
                                  {v.dataTypeRequired === 'Reason' ? <SelectSetting id={`dataEntry[${i}].dataSource`} string label="Data" endpoint={endpoints.getReasonNames} /> : null}
                                  {v.dataTypeRequired === 'BiddingEndDate' ? <SelectSetting id={`dataEntry[${i}].dataSource`} string label="Data" endpoint={endpoints.getDateFields} /> : null}
                                  {v.dataTypeRequired === 'TermsAndConditions' || v.dataTypeRequired === 'EmailContent'?<SelectSetting id={`dataEntry[${i}].dataSource`} endpoint={endpoints.getTermsAndConditionsTypes}  />:null}
                                    </Col>
                              {edit ? <Col>
                                  <Row>
                                      <Label>&nbsp</Label>
                                  </Row>
                                  <Row>
                                      <Button onClick={() => removeDataEntry(i)}>-</Button>
                                  </Row>
                              </Col> : null}
                                </Row>
                      })}
                      {values.actionType === "Route" || values.actionType === "ListRoute" ? <FormInput id='appRoute' label='App Route' /> : null}
                                   <EntityStatusSelector id='nextState' entityType={'entityType'} label="Next State" />
                            
                            <FormInput id='actionDescription' label='Description' type='textarea' />
         
    </React.Fragment>
};


        














export default AllowedActionDetail;
